import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const inMs    = parseInt(this.element.dataset.flashInMs)
    const solidMs = parseInt(this.element.dataset.flashSolidMs)
    const outMs   = parseInt(this.element.dataset.flashOutMs)

    this.element.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: inMs, easing: "ease-out", fill: "forwards" }
    )

    if (!outMs) return

    this.timeout = setTimeout(() => {
      this.element.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: outMs, easing: "ease-in", fill: "forwards" }
      ).finished.then(() => this.element.remove())
    }, solidMs)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
